import { useMutation, useQueryClient } from '@tanstack/react-query';
import { DCKDiagnosisApi } from 'api/DCK/DCKDiagnosisApi';
import { useLoadingStore } from 'store/useLoadingStore';
import { useLoginStore } from 'store/useLoginDataStore';

const useDiagnosisChangeStatusMutation = () => {
    const queryClient = useQueryClient();
    const { loginData } = useLoginStore();
    const { setLoading } = useLoadingStore();

    return useMutation({
        mutationFn: async (rqData: { _id: string; status: number }) => {
            try {
                setLoading(true);

                const response = await DCKDiagnosisApi.changeDiagnosisStatus(rqData, loginData.token);
                if (response.status === 'ok') return response.data;
                throw new Error('API 응답 오류');
            } catch (error) {
                const errorMessage = error instanceof Error ? error.message : '알 수 없는 오류가 발생했습니다';
                throw new Error(errorMessage);
            } finally {
                setLoading(false);
            }
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['diagnosis'] });
        },
        retry: 1, // 오류 시 재시도 횟수
    });
};

export default useDiagnosisChangeStatusMutation;
